export const state = {
    collectionlist_loading_status: null, // when waiting on api we set this true or
    collectionsList: [],

    all_team_members: [], // i.e valiators
};

export const getters = {};

export const actions = {
    setCollectionListLoadingStatus({ commit }, value) {
        commit("client_loading_status", value);
    },
    // fetches collection list data and sets it to the variable in state
    setCollectionList({ commit }) {
        commit("setCollectionListLoadingStatus", true);
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/collections/collectionclients")
                .then((response) => {
                    commit("setCollectionList", response.data);
                    commit("setCollectionListLoadingStatus", false);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    // deletes a client from the collection list
    //eslint-disable-next-line
    deleteCollectionListRecord({ commit }, params) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/collections/deletecollectionclient", params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                });
        });
    },
    // adds a single client to the collection list
    //eslint-disable-next-line
    addClientToCollectionList({ commit }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/collections/savecollections", requestObject)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                });
        });
    },
    /**
     *
     * This method assigns validators to a client, the request object will contain:
     * string: collection_id, array: validators
     * @param {*} requestObject
     * @returns
     */
    //eslint-disable-next-line
    assignTeamMembersToClient({ commit }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/collections/savevalidators", requestObject)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setTeamMembers({ commit }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/admin/roleusers", { params: { role_name: "Certificate Team" } })
                .then((response) => {
                    commit("setTeamMembers", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
};

export const mutations = {
    setCollectionListLoadingStatus(state, payload) {
        state.collectionlist_loading_status = payload;
    },
    setCollectionList(state, payload) {
        state.collectionsList = payload;
    },
    setTeamMembers(state, payload) {
        state.all_team_members = payload;
    },
};
